// extracted by mini-css-extract-plugin
export default {"popupWrapper":"SponsorPopup_popupWrapper__KiMWE","parentDiv":"SponsorPopup_parentDiv__ulT3S","contentDiv":"SponsorPopup_contentDiv__lCVPW"};